import { SearchSelectbox } from "cpl-react-common/components/Inputs/SearchSelectbox";
import { useSelector } from "react-redux";
import {
  getClientSelectModels,
  selectClientSelectModels,
  selectLastUpdateTime,
  selectLoading,
} from "./components/ClientSelectSlice";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import { ActivityIndicator } from "cpl-react-common/components/ActivityIndicators/ActivityIndicator";
import { GuidSelectModel } from "services/api/cplapi/CPLAPI";

type ClientSelectProps = {
  "data-test-id"?: string;
  handleChange: (selection: GuidSelectModel) => void;
  defaultSelectedValue?: string;
  disabled?: boolean;
  enableReinitialise?: boolean;
};

const EXPIRY_PERIOD_MS = 1000 * 60 * 30; // 30 minutes

const ClientSelect: React.FC<ClientSelectProps> = ({
  "data-test-id": testId,
  handleChange,
  defaultSelectedValue,
  disabled,
  enableReinitialise,
}) => {
  const loading = useSelector(selectLoading);
  const clientSelectModels = useSelector(selectClientSelectModels);
  const lastUpdateTime = useSelector(selectLastUpdateTime);
  const thunkDispatch = useThunkDispatch();

  const updateSelectModels = () => {
    thunkDispatch(getClientSelectModels());
  };

  const defaultSelected = clientSelectModels.find((x) => x.value === defaultSelectedValue);

  return (
    <ActivityIndicator isBusy={loading}>
      <SearchSelectbox
        data-test-id={testId}
        handleChange={(selection) => {
          handleChange(new GuidSelectModel({ value: selection.value.toString(), label: selection.label }));
        }}
        selectOptions={clientSelectModels.map((x) => ({
          value: x.value ?? "",
          label: x.label ?? "",
        }))}
        cachingOptions={{
          lastUpdateTime,
          expiryPeriodMs: EXPIRY_PERIOD_MS,
          updateData: updateSelectModels,
          shouldUpdateOnLoad: clientSelectModels.length === 0,
        }}
        defaultSelected={
          defaultSelected !== undefined
            ? { value: defaultSelected.value ?? "", label: defaultSelected.label ?? "" }
            : undefined
        }
        disabled={disabled}
        enableReinitialise={enableReinitialise}
      />
    </ActivityIndicator>
  );
};

export default ClientSelect;
